
import { useEffect, useState } from "react";
import OrderDetailSummary from "./OrderDetailSummary";
import OrderViewUpdateByProcessor from "./OrderViewUpdateByProcessor";
import OrderViewUpdateByRequester from "./OrderViewUpdateByRequester";
import { OrderService } from "../../services/OrderService";
import { useRecoilState } from "recoil";
import { orderState, orderWorkFlowState } from "../../states/Order.state";
import { Order } from "../../model/Order";
import { useLocation, useParams } from "react-router-dom";
import { ORDER_STATUS_DRAFT, orderActionStatusList, permissions } from "../../common/constants";
import moment from "moment";
import { useAuth } from "react-oidc-context";
import { getUserEmail, hasResourceRole } from "../../utils/tokens";
import Unauthorized from "../Unauthorized/Unauthorized";
import PageLoader from "../../components/PageLoader";
import { WorkFlowType } from "../../model/enums/Constants";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from 'dayjs/plugin/timezone';
import { showNotificationState } from "../../states/Common.state";
import { UserComment } from "../../model/Base";

interface IOrderDetailProps {
}
const OrderView: React.FC<IOrderDetailProps> = (props) => {
  const [orderData, setOrderData] = useRecoilState<Order>(orderState);
  const [orderWorkFlow, setOrderWorkFlow] = useRecoilState<string>(orderWorkFlowState);
  const { orderId, orderNumber } = useParams();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const [showNotification, setShowNotification] = useRecoilState<boolean>(showNotificationState);
  
  
  dayjs.extend(utc);
  dayjs.extend(timezone);

  useEffect(() => {
    async function getOrderData() {
      if(orderId || orderNumber){
        setLoading(true);
        let order = orderId
          ? await OrderService.getById(orderId)
          : orderNumber
          ? await OrderService.getByOrderNumber(orderNumber)
          : null;
        if(order && order.data){
          order.data.statusDesc = orderActionStatusList.find(i => i.value === order?.data.status)?.label??"";
          order.data.orderDatePrintable =order.data.orderDate? dayjs.utc(order?.data.orderDate).tz("America/Edmonton", false).format("YYYY-MM-DD HH:mm"):"";
          order.data.submittedDatePrintable=order.data.submittedDate? dayjs.utc(order?.data.submittedDate).tz("America/Edmonton", false).format("YYYY-MM-DD HH:mm"):"";
          order.data.requiredByPrintable = order.data.orderDate?dayjs.utc(order?.data.requiredBy).tz("America/Edmonton", false).format("YYYY-MM-DD HH:mm"):"";
          order.data.printDateTime = moment(new Date()).format('YYYY-MM-DD HH:mm');
          order.data.orderingForName = order.data.orderingForName?.replace(/\s*\(.*?\)/g, "");
          order.data.isPersonnelOrderType=order.data.orderType==="Personnel";
          order.data.orderDate = order.data.orderDate?new Date(
            dayjs
              .utc(order.data.orderDate)
              .tz("America/Edmonton", false)
              .format()
          ):null;
          order.data.comments = order.data.comments
              ?.sort(  (a: UserComment, b: UserComment) => {
                return new Date(b.postDate).getTime() - new Date(a.postDate).getTime();
              })
              .map((comment) => {
                return {
                  ...comment,
                  postDateString: comment.postDate
                    ? `${dayjs(comment.postDate).tz("America/Edmonton", false).format("dddd, MMMM D, YYYY [at] HH:mm")} (MST)`
                    : "",
                };
              });

                           
          setOrderData(order.data);
          setOrderWorkFlow(getWorkFlow(order.data.auditTrail.createdBy, order.data.status));
          setLoading(false);
          setShowNotification(false);
          console.log(showNotification);
        }
      }
    }
    getOrderData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const getWorkFlow = (orderCreatedBy: string, orderStatus: number) => {
    let workflow = WorkFlowType.REQUESTER;
    if (hasProcessorPermission) {
      workflow = WorkFlowType.PROCESSOR;
      if (orderCreatedBy === getUserEmail(auth?.user?.access_token ?? "") && orderStatus === ORDER_STATUS_DRAFT) {
        workflow = WorkFlowType.REQUESTER;
      }
    }
    return workflow;
  };
  
  const hasProcessorPermission = hasResourceRole(
    String(process.env.REACT_APP_RESOURCEORDERS_CLIENT),
    permissions.ORDER_STATUS_UPDATE,
    auth.user?.access_token ?? ""
  );
  

  return (
    <> 
     <PageLoader visible={loading} />
      {(!loading && orderData.auditTrail?.createdBy !== getUserEmail(auth?.user?.access_token ?? "") && orderData.status === ORDER_STATUS_DRAFT) ? <Unauthorized /> :
      (!loading && <div className="content-padding">
      <OrderDetailSummary orderData={orderData} isProcessor={orderWorkFlow === WorkFlowType.PROCESSOR}></OrderDetailSummary>
      {orderWorkFlow === WorkFlowType.PROCESSOR ? <OrderViewUpdateByProcessor orderData={orderData} redirectedFrom={state?.redirectedFrom??''}/> : <OrderViewUpdateByRequester orderData={orderData} redirectedFrom={state?.redirectedFrom??''}/>}
    </div>)}
    </>
  );
};

export default OrderView;
